const BN_LABELS = {
  AU: 'ABN',
  NZ: 'NZBN',
} as const;

const getBnLabel = (country: string) => (country === 'NZ' ? BN_LABELS.NZ : BN_LABELS.AU);

export const getBadgeTexts = (country: string) => {
  const bn = getBnLabel(country);
  return {
    verified: `${bn} VERIFIED`,
    verifiedNoGst: `${bn} VERIFIED - NO GST`,
    cancelled: `${bn} CANCELLED`,
    invalid: `${bn} INVALID`,
    notValidated: 'NOT VALIDATED',
  };
};

export const getTooltipTexts = (country: string) => {
  const bn = getBnLabel(country);
  return {
    name: 'Name',
    bn,
    entityType: 'Entity Type',
    gstStatus: 'GST Status',
    gstStatusFallback: 'N/A',
    verifiedOn: 'Verified on',
  };
};
